const socketRoot = 'wss://toilets.xuruidea.com/ws/web/' // 服务器

export default {
  socketRoot
}